import React from 'react'
import { Button, Icon, Modal } from 'semantic-ui-react'
import Proptypes from 'prop-types'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import styles from '../../device/device-info-view/device-view.module.css'
import IntelMsg from '../../../ItelMsg'
import { deleteDeviceRelations } from '../../../../services/device-page-list'

const DeleteModal = ({ open, setOpenDeleteModal }) => {
  const { deviceData } = useSelector((store) => ({
    deviceData: store.deviceData.deviceData,
  }))

  const handleDelete = async () => {
    Swal.showLoading()
    const res = await deleteDeviceRelations(deviceData['device id'])
    console.log('res: ', res.status)
    if (res.status !== 200) Swal.fire('Error deactivating device', '', 'error')
    else {
      await Swal.fire({
        title: 'Device Deactivated Successfully!',
        confirmButtonColor: 'Green',
        icon: 'success',
      })
      setOpenDeleteModal(false)
    }
  }
  return (
    <Modal
      size="small"
      open={open}
      style={{ position: 'relative', height: 'auto' }}
    >
      <Modal.Header className={styles.header}>Deactivate Device</Modal.Header>
      <Modal.Content image style={{ alignItems: 'center' }}>
        <Icon name="warning circle" size="huge" />
        <p style={{ fontSize: 'x-large' }}>
          <IntelMsg id="deleteMsg" />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button negative onClick={handleDelete}>
          <IntelMsg id="yes" />
        </Button>
        <Button
          className={styles.positiveStatus}
          onClick={() => setOpenDeleteModal(false)}
        >
          <IntelMsg id="no" />
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

DeleteModal.propTypes = {
  open: Proptypes.bool.isRequired,
  setOpenDeleteModal: Proptypes.func.isRequired,
}

export default DeleteModal
